import { api, TOKEN_KEY } from "./api";

export const DEMO_KEY = "valeriia_demo";
// Registries: later phases flip `live` / add entries to expose new roles and modules in the demo.
export const DEMO_ROLES = [
  { key: "groomer", live: true, path: "/home" },
  { key: "owner", live: true, path: "/owner" },
  { key: "mentor" },
  { key: "salon_manager" },
  { key: "academy_instructor" },
];
export const DEMO_MODULES = ["learning", "mentoring", "revisions", "timelines", "salon", "academy", "case_library", "authorship", "reports", "payments", "ai"];

export const getDemo = () => {
  try { return JSON.parse(localStorage.getItem(DEMO_KEY)); } catch { return null; }
};
export const setDemo = (d) => localStorage.setItem(DEMO_KEY, JSON.stringify(d));
export const patchDemo = (p) => setDemo({ ...getDemo(), ...p });
export const clearDemo = () => localStorage.removeItem(DEMO_KEY);

async function open(url, lang) {
  const { data } = await api.post(url, { lang });
  setDemo({ ...data, role: "groomer", step: 0, guide: true });
  localStorage.setItem(TOKEN_KEY, data.groomer_token);
  return data;
}
export const startDemo = (lang) => open("/demo/start", lang);
export const resetDemo = (lang) => open("/demo/reset", lang);

export function switchDemoRole(role) {
  const d = getDemo();
  patchDemo({ role });
  localStorage.setItem(TOKEN_KEY, role === "owner" ? d.owner_token : d.groomer_token);
}

const subs = new Set();
export const onSimulated = (fn) => { subs.add(fn); return () => subs.delete(fn); };
export const showSimulated = (previews) => subs.forEach((f) => f(previews.filter(Boolean)));
